// extracted by mini-css-extract-plugin
module.exports = {"verticallyCenter":"verticallyCenter--3qVWDa_P","horizontalCenter":"horizontalCenter--ZwEv2pho","main":"main--2MuMQtCP"};